module.exports = __webpack_public_path__ + "static/media/User_2@3x.70e3e4be.png";